export const isBuyerView = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const params = new URLSearchParams(window.location.search)
  return params.get('view') === 'buyer'
}
